module.exports = __webpack_public_path__ + "static/media/arrow-left-white.cd677110.svg";